/**
 * Constrains the value of an number input element to its specified min and max attributes
 */
angular.module('logbook').directive('inputNumberConstraint', [function()
{
	return {
		restrict: 'A',
		
		link: {
			pre: function(scope, element, attributes)
			{
				element = element[0];
				if (!element) return;
				
				function compare(value, min, max)
				{
					value = parseInt(value);
					min = parseInt(min);
					max = parseInt(max);
					
					if (isNaN(value))
						return (!isNaN(min)) ? min : '';
					
					if (!isNaN(min) && value < min)
						return min;
					else if (!isNaN(max) && value > max)
						return max;
					return value;
				};
				
				function onChange($event)
				{
					var min = parseInt(element.getAttribute('min'));
					var max = parseInt(element.getAttribute('max'));
					var val = parseInt(element.value);
					
					element.value = compare(val, min, max);
				}
				
				element.addEventListener('change', onChange);
				
				element.addEventListener('input', function($event)
				{
					var min = parseInt(element.getAttribute('min'));
					var max = parseInt(element.getAttribute('max'));
					var val = element.value;
					
					if (val.length <= 0)
						return;
					
					else
						val = parseInt(val);
					
					element.value = compare(val, min, max);
				});
				
				onChange(null);
			}
		}
	}
}]);